import { render, staticRenderFns } from "./article.vue?vue&type=template&id=8c694c9e&"
import script from "./article.vue?vue&type=script&lang=ts&"
export * from "./article.vue?vue&type=script&lang=ts&"
import style0 from "./article.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports